import { NavLink } from "react-router-dom";
import Button from "components/ui/Button/Button";
import PartnerForm from "components/Forms/PartnerForm/PartnerForm";

const PartnerDetail = () => {
  return (
    <>
      <NavLink to=".."><Button type="button" className="btn-secondary mb-5">Terug naar partners</Button></NavLink>
      <PartnerForm />
    </>
  );
};

export default PartnerDetail;
